/* Sommaire automatique (articles, pages, politiques) : un lien par Titre 2. */
class FalcoToc extends HTMLElement {
  connectedCallback() {
    const src = this.querySelector("[data-toc-source]");
    if (!src) return;
    const heads = [...src.querySelectorAll("h2")];
    if (!heads.length) return;
    const slug = (s) => "s-" + s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    heads.forEach((h) => { if (!h.id) h.id = slug(h.textContent); h.classList.add("scroll-mt-[7rem]"); });
    this.querySelectorAll("[data-toc-list]").forEach((ul) => {
      ul.replaceChildren(...heads.map((h) => { const li = document.createElement("li"); const a = document.createElement("a"); a.href = `#${h.id}`; a.textContent = h.textContent; a.className = "block py-1 text-[0.875rem] leading-snug text-gris transition-colors hover:text-graphite"; li.appendChild(a); return li; }));
    });
    const count = this.querySelector("[data-toc-count]"); if (count) count.textContent = `${heads.length} sections`;
    this.querySelectorAll("[data-toc-mobile], [data-toc-desktop]").forEach((el) => (el.hidden = false));
    src.querySelectorAll("table").forEach((t) => { if (!t.parentElement.classList.contains("table-wrap")) { const w = document.createElement("div"); w.className = "table-wrap no-scrollbar"; t.replaceWith(w); w.appendChild(t); } });
  }
}
customElements.define("falco-toc", FalcoToc);
